// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.user_container {
  padding: 20px 24px;
}

.tabContainer {
  margin-top: 50px;
}
.billingTabs {
  display: inline-flex;
  justify-content: space-between;
  background: var(--icon2-bg-color);
  border-radius: 4px;
}
.billingTabs button {
  padding: 10px 20px;
  cursor: pointer;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 18px;
  font-weight: 500;
  color: var(--dark-color);
}

.billingTabs button.active {
  background-color: #007bff;
  color: white;
}
/* button:first-child.active {
  border-radius: 8px 0 0 8px;
} */

/* button:last-child.active {
  border-radius: 0 8px 8px 0;
} */`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Billing Page/BillingStyle.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,iCAAiC;EACjC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;;GAEG;;AAEH;;GAEG","sourcesContent":["\n.user_container {\n  padding: 20px 24px;\n}\n\n.tabContainer {\n  margin-top: 50px;\n}\n.billingTabs {\n  display: inline-flex;\n  justify-content: space-between;\n  background: var(--icon2-bg-color);\n  border-radius: 4px;\n}\n.billingTabs button {\n  padding: 10px 20px;\n  cursor: pointer;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--dark-color);\n}\n\n.billingTabs button.active {\n  background-color: #007bff;\n  color: white;\n}\n/* button:first-child.active {\n  border-radius: 8px 0 0 8px;\n} */\n\n/* button:last-child.active {\n  border-radius: 0 8px 8px 0;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
